import styled from "styled-components";
import { Box } from "@similarweb/ui-components";
import { SWReactIcons } from "@similarweb/icons";
import { Text } from "./styledComponents";
import { colorsPalettes, rgba, fonts } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { i18nFilter } from "app/filters/i18nFilter";
import type { INavigationTileProps } from "app/pages/digital-marketing/home-pages/MajorNavigationTile";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { allTrackers } from "app/services/track/track";

const BoxStyled = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 158px;
    text-align: center;
    padding: 16px;
    box-sizing: border-box;
    cursor: pointer;
    border: 1px solid transparent;

    &:hover {
        border: 1px solid ${colorsPalettes.carbon[100]};
        box-shadow: 0 3px 5px ${rgba(colorsPalettes.carbon[400], 0.12)};
    }
`;

const SWReactIconsStyled = styled(SWReactIcons)`
    margin-bottom: 16px;
`;

const MajorNavigationTitle = styled(Text).attrs(() => ({
    color: colorsPalettes.carbon[500],
}))`
    ${(props) =>
        setFont({
            $size: 16,
            $weight: "500",
            $color: props.color,
            $family: fonts.$dmSansFontFamily,
        })};
    display: flex;
    text-transform: capitalize;
    margin-bottom: 4px;
`;

const SubTitle = styled(Text).attrs(() => ({
    color: colorsPalettes.carbon[300],
}))`
    font-size: 14px;
`;

const IconsWrapper = styled(FlexRow)`
    justify-content: center;
    width: 100%;
    position: relative;
    ${SWReactIcons} {
        display: flex;
        align-items: center;
    }
`;

const PillWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
`;

export const MajorNavigationTile: React.FC<INavigationTileProps> = ({
    iconName,
    title,
    subTitle,
    navigationState,
    id,
    useRedirect = false,
    pill: PillComponent,
}) => {
    const i18n = i18nFilter();

    const handleNavigation = () => {
        allTrackers.dispatchTrackEvent("Internal Link", "click", `${i18n(title) || ""}`);
        if (useRedirect) {
            proNavigator.go("acquisitionRedirect", { id });
        } else {
            proNavigator.go(navigationState);
        }
    };

    return (
        <BoxStyled onClick={handleNavigation}>
            <IconsWrapper>
                <SWReactIconsStyled
                    iconName={iconName}
                    size="xl"
                />
                {PillComponent ? <PillWrapper>{PillComponent()}</PillWrapper> : null}
            </IconsWrapper>
            <MajorNavigationTitle>{i18n(title)}</MajorNavigationTitle>
            <SubTitle>{i18n(subTitle)}</SubTitle>
        </BoxStyled>
    );
};
